<template>
  <div class="row">
    <div class="col-md-6">
      <table>
        <tbody class="vuetable-body">
          <tr>
            <td><b> {{ 'Joint ID' | translate }} </b></td>
            <td> {{ rowData.joint_id }} </td>
          </tr>
          <tr>
            <td><b> {{ 'Machine ID' | translate }} </b></td>
            <td> {{ rowData.name }} </td>
          </tr>
          <tr>
            <td><b> {{ 'stored' | translate }} </b></td>
            <td> {{ rowData.stored }} </td>
          </tr>
          <tr>
            <td><b> {{ 'dimension' | translate }} </b></td>
            <td> {{ rowData.dimension }} </td>
          </tr>
          <tr>
            <td><b> {{ 'timestamp' | translate }} </b></td>
            <td> {{ rowData.datetime }} </td>
          </tr>
          <tr>
            <td><b> {{ 'u_mains' | translate }} </b></td>
            <td> {{ rowData.u_mains }} </td>
          </tr>
          <tr>
            <td><b> {{ 'mode' | translate }} </b></td>
            <td> {{ rowData.mode }} </td>
          </tr>
          <tr>
            <td><b> {{ 'channel' | translate }} </b></td>
            <td> {{ rowData.channel }} </td>
          </tr>
          <tr>
            <td><b> {{ 'alarm' | translate }} </b></td>
            <td> {{ 'ALARM-' + rowData.alarm | translate }} </td>
          </tr>
          <tr>
            <td><b> {{ 'temps' | translate }} </b></td>
            <td> {{ rowData.temps.filter(Boolean).join(', ') }}</td>
          </tr>
          <tr>
            <td><b> {{ 'joint_time_a' | translate }} </b></td>
            <td> {{ calcJointTime(rowData.joint_time_a) }} </td>
          </tr>
          <tr v-if="rowData.comment">
            <td><b> {{ 'Comment' | translate }} </b></td>
            <td> {{ rowData.comment }} </td>
          </tr>

        </tbody>
      </table>
    </div>
    <div class="col-md-6">
        <temp-curve-chart class="chart-wrapper" :chartData="prepDataset(rowData.temps)" style="height:300px;margin-top:40px;" height="300"></temp-curve-chart>
    </div>
  </div>
</template>

<script>
import TempCurveChart from '../components/TempCurveChart'
export default {
  components: {
    TempCurveChart
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  data: () => {
    return {
      labels: [0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 'Minutes']
    }
  },
  methods: {
    calcJointTime (val) {
      var min = Math.floor(val / 10)
      var sec = ((val / 10) - min).toFixed(2) * 10 * 6
      return min + ' ' + this.$t('TIME-min') + ' ' + sec + ' ' + this.$t('TIME-sec')
    },
    prepDataset (data) {
      var dta = data.slice(0) // Add initial zero
      dta.splice(0, 0, 0)
      return {
        max: Math.max(...data),
        labels: this.labels,
        datasets: [
          {
            label: 'Temperature over time',
            lineTension: 0,
            backgroundColor: 'rgba(255,255,255,0)',
            borderColor: '#63c2de',
            pointHoverBackgroundColor: '#fff',
            orderWidth: 2,
            data: dta
          }
        ]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// JointDetailRow.vue?901c68ba